var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('label', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("Download Proof Of Pickup")])])])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('b-card', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmitSearch($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Shipment ID")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-crosshairs' style='font-size: 12px'></i>"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AWB),
      expression: "AWB"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "txt",
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "AWB",
      "id": "AWB",
      "placeholder": "Enter upto 10 AWB No"
    },
    domProps: {
      "value": (_vm.AWB)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.onPageChange(1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.AWB = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Client Short/Display Name")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bank'></i>"
    }
  }, [_c('Multiselect', {
    attrs: {
      "options": _vm.companyNamelist,
      "name": "companyName",
      "placeholder": "Select Client",
      "label": "label",
      "track-by": "id",
      "multiple": false,
      "scroll": true
    },
    model: {
      value: (_vm.companyName),
      callback: function($$v) {
        _vm.companyName = $$v
      },
      expression: "companyName"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Origin Hub Name")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bank'></i>"
    }
  }, [_c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "pophubname",
    attrs: {
      "options": _vm.hubnamelist,
      "clearable": false,
      "name": "hubname",
      "placeholder": "Select Hub Name",
      "label": "text",
      "track-by": "value",
      "multiple": false,
      "scroll": true,
      "hide-selected": true
    },
    model: {
      value: (_vm.hubname),
      callback: function($$v) {
        _vm.hubname = $$v
      },
      expression: "hubname"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Pickup Date Range ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-calendar-o'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "range": "",
      "not-after": _vm.disabledAfter,
      "shortcuts": _vm.shortcuts,
      "lang": "en",
      "name": "pickupDate",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.pickupDate),
      callback: function($$v) {
        _vm.pickupDate = $$v
      },
      expression: "pickupDate"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.searchPOPShipment()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")]), _vm._v("   \n\t\t\t\t\t\t\t\t\t\t\t"), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        _vm.clearForm()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset\n\t\t\t\t\t\t\t\t\t\t\t")])])], 1)])])])])])], 1)]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v(" Proof Of Pickup List")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("Total Records: " + _vm._s(_vm.totalCount))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('custom-expandable-table', {
    attrs: {
      "columns": _vm.tableColumn,
      "items": _vm.tableItems,
      "innerTableHeader": _vm.innerTableColumn,
      "offset": _vm.offset,
      "isViewHidden": true,
      "isDownloadImage": true,
      "isEditHidden": true,
      "isViewImage": true
    },
    on: {
      "customTableEvent": _vm.getCustomTableEvent
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalCount,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  })], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg"
    },
    on: {
      "ok": function($event) {
        _vm.ProofOfPickupImages = false
      }
    },
    model: {
      value: (_vm.ProofOfPickupImages),
      callback: function($$v) {
        _vm.ProofOfPickupImages = $$v
      },
      expression: "ProofOfPickupImages"
    }
  }, [_c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isImageLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isImageLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_c('b', [_vm._v("Proof Of Pickup Images")])]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeProofOfPickupImages
    }
  }, [_vm._v("\n\t\t\t\t\t\t×\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', [_vm._v("Proof Of Pickup Images\n\t\t\t\t\t\t\t"), _c('div', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("(Click on the image to view it)")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.popimagearray), function(item) {
    return _c('div', {
      staticClass: "col-md-5"
    }, [_c('br'), _vm._v(" "), (item) ? _c('img', {
      staticStyle: {
        "cursor": "pointer",
        "width": "65px",
        "margin-left": "9rem",
        "height": "65px"
      },
      attrs: {
        "src": item,
        "alt": "NO Image",
        "title": "Open Image"
      },
      on: {
        "click": function($event) {
          _vm.openImage(item)
        }
      }
    }) : _vm._e(), _vm._v(" "), (item) ? _c('i', {
      staticClass: "fa fa-download",
      staticStyle: {
        "cursor": "pointer",
        "font-size": "1rem",
        "margin-left": "20px",
        "margin-right": "10px",
        "margin-top": "1rem"
      },
      attrs: {
        "aria-hidden": "true",
        "title": "Download Image"
      },
      on: {
        "click": function($event) {
          _vm.fileview(item)
        }
      }
    }) : _vm._e()])
  }))])])], 1)], 1)], 1), _vm._v(" "), _c('section', [_c('img', {
    staticStyle: {
      "width": "100%",
      "max-width": "300px"
    },
    attrs: {
      "id": "myImg",
      "id": 'imgid' + _vm.image
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": 'myModalImg' + _vm.image
    }
  }, [_c('span', {
    staticClass: "closemodel",
    staticStyle: {
      "cursor": "pointer",
      "float": "right",
      "margin-right": "30px"
    },
    attrs: {
      "title": "Close Image"
    },
    on: {
      "click": function($event) {
        _vm.closemodal('myModalImg' + _vm.image)
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "auto",
      "display": "block",
      "width": "80%",
      "max-width": "700px",
      "text-align": "center",
      "color": "rgb(204, 204, 204)",
      "padding": "0px 0px",
      "height": "35px",
      "font-size": "20px !important"
    },
    attrs: {
      "id": 'captionImg' + _vm.caption
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "modal-content1",
    attrs: {
      "id": 'img' + _vm.image,
      "src": _vm.image
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "auto",
      "display": "block",
      "width": "80%",
      "max-width": "700px",
      "text-align": "center",
      "color": "#ccc",
      "padding": "10px 0",
      "height": "150px"
    }
  })])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-683ae42a","hasScoped":true}!./src/modules/utility/views/proofofpickup/proofofpickup.component.html
// module id = 2205
// module chunks = 3